import { get } from 'lodash/fp'

export const getEntryComponent = (state) => get('entryComponent')(state)
